import { connect } from 'react-redux';
import { InstitutionSettingsNav } from './component';
import {
  selectCurrentInstitution,
  selectIsAdminOfCurrentInstitution,
} from '../../../../ReduxStorage/Institutions/selectors';
import { selectCurrentInstitutionAdminAction } from '../selectors';
import { selectOptimizelyEnabledFeatures } from '../../../../ReduxStorage/Optimizely/selectors';
import { selectCurrentPortalForInstitutionSetting } from '../../../../ReduxStorage/Portals/selectors';
import { ReduxState } from '../../../../ReduxStorage/state';

export const ConnectedInstitutionSettingsNav = connect((state: ReduxState) => ({
  institution: selectCurrentInstitution(state),
  portal: selectCurrentPortalForInstitutionSetting(state),
  isAdmin: selectIsAdminOfCurrentInstitution(state),
  action: selectCurrentInstitutionAdminAction(state),
  enabledFeatures: selectOptimizelyEnabledFeatures(state),
}))(InstitutionSettingsNav);
